import React from 'react';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, isDeleting }) => {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ padding: 24, maxWidth: 400 }}>
        <i className="fas fa-exclamation-triangle" style={{ fontSize: 48, color: "#f39c12" }} />
        <h3>Confirm Delete</h3>
        <p>Are you sure you want to delete this note and all associated files? This action cannot be undone.</p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
          <button onClick={onClose} style={{ padding: "10px 20px", background: "#fff", border: "1px solid #bdc3c7" }}>Cancel</button>
          <button onClick={onConfirm} disabled={isDeleting} style={{ background: "#e74c3c", color: "#fff", border: "none", padding: "10px 20px" }}>
            {isDeleting ? "Deleting..." : "Delete Note & Files"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;